import type { FC } from "react";
import { useEffect, useState } from "react";

import { getUser } from "@jti/rest-api";
import { Iframe } from "@jti/ui/components/Iframe";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import styles from "./SurveyMonkey.module.scss";

type SurveyProps = {
  scriptUrl: string;
};

export const SurveyMonkey: FC<SurveyProps> = (props) => {
  const { __ } = useTranslations();
  const { scriptUrl } = props;

  const [surveyType, setSurveyType] = useState<string | undefined>(undefined);
  const [uniqueCode, setUniqueCode] = useState<string | undefined>(undefined);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setSurveyType(params.get("surveyType") || undefined);
    setUniqueCode(params.get("uniqueCode") || undefined);
  }, []);

  const user = getUser();
  const isSurveyDataValid = () => {
    if (!user.uuid || !uniqueCode) {
      const errorReason = `${__("loyalty.surveymonkey.iframe.error_message")}${!user.uuid ? "user UUID" : ""} ${
        !uniqueCode ? "promo code" : ""
      }`.trim();

      return errorReason;
    }
    return null;
  };

  const error = isSurveyDataValid();
  if (error) {
    return (
      <div className={styles.error}>
        <p>{error}</p>
      </div>
    );
  }

  const surveyUrl = `${encodeURIComponent(scriptUrl)}?survey_type=${encodeURIComponent(
    surveyType || "weekly-survey"
  )}&user_id=${encodeURIComponent(user.uuid!)}&unique_code=${encodeURIComponent(uniqueCode!)}`;

  return (
    <div className={styles.surveymonkey}>
      <Iframe src={decodeURIComponent(surveyUrl)} title={__("loyalty.surveymonkey.iframe.title")} />
    </div>
  );
};
